import { isMobile } from "../../common/Helper";
import AttractionDescription from "../../components/AttractionDescription";
import AttractionMainBannerSection from "../../components/AttractionMainBannerSection";
import BreadCrumb from "../../components/BreadCrumb";

import NearbyAttractions from "../../components/NearbyAttractions";

const Index = ({
    productList, isLoading, attractionNextPageUrl, onClickLoadMore, isAttractionLoading, attractionDetail,
    expanded,
    setExpanded,
    descriptionRef,
    isOverflowing,
    breadcrumbList,
    locationDetail
}) => {
    let desc = isMobile()? attractionDetail?.mobile_description : attractionDetail?.description
    let haveDesc = desc ? true : false
    return (
        <>
            <AttractionMainBannerSection attractionDetail={attractionDetail} isLoading={isLoading} locationDetail={locationDetail} />
            <div className="container">
                <BreadCrumb list={breadcrumbList} />
            </div>

            {
                haveDesc &&
                <AttractionDescription
                    name={attractionDetail?.name}
                    description={isMobile()? attractionDetail?.mobile_description : attractionDetail?.description}
                    expanded={expanded}
                    setExpanded={setExpanded}
                    descriptionRef={descriptionRef}
                    isOverflowing={isOverflowing}
                />
            }

            <NearbyAttractions

                title={'Explore tours'}
                productList={productList}
                isLoading={isLoading}
                attractionNearNextPageUrl={attractionNextPageUrl}
                onClickLoadMore={onClickLoadMore}
                isAttractionNearLoading={isAttractionLoading}
            />


        </>

    )
}
export default Index;